import { getValueByDotNotation } from '../helpers/GeneralHelper';

export default (watchProperties, methodName) => {
    return {
        mounted() {
            this.$watch(
                (vm) => {
                    return watchProperties.map((x) =>
                        getValueByDotNotation(vm, x)
                    );
                },
                (values, oldValues) => {
                    const changes = {};
                    watchProperties.forEach((key, index) => {
                        changes[key] = {
                            value: values[index],
                            oldValue: oldValues[index],
                            changed: values[index] != oldValues[index],
                        };
                    });

                    const func = this[methodName];
                    func(changes);
                }
            );
        },
    };
};
